import React from 'react'
import styled from 'styled-components'
import { BaseProps } from '../types/props'
import { contrastColor, overloadColor } from '../util/style'
import { isUndefined } from '../util/typechecks'

interface WrapperProps {
  top?: string
  right?: string
  bottom?: string
  left?: string

  width?: string
  minWidth?: string
  height?: string
  size: number
  fontSize: string
  color?: string
  background: string

  boxShadow?: string
  border?: string

  translateTextX: string
  translateTextY: string
  pointerEvents: string
}
const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  top: ${props => props.top};
  right: ${props => props.right};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  z-index: 1;
  pointer-events: ${props => props.pointerEvents};

  display: flex;
  justify-content: center;
  align-items: center;

  width: ${props => props.width ?? `${props.size}px`};
  min-width: ${props => props.minWidth};
  height: ${props => props.height ?? `${props.size}px`};
  border-radius: 999px;

  color: ${props =>
    props.color ? overloadColor(props.color) : contrastColor(props.background)};
  background: ${props => overloadColor(props.background)};
  box-shadow: ${props => props.boxShadow};

  border: ${props => props.border};

  font-size: ${props => props.fontSize};

  span {
    user-select: none;
    transform: translate(
      ${props => props.translateTextX},
      ${props => props.translateTextY}
    );
  }
`

export interface BadgeProps extends BaseProps {
  text: React.ReactText

  top?: string
  right?: string
  bottom?: string
  left?: string

  width?: string
  minWidth?: string
  height?: string
  size?: number
  fontSize?: string
  color?: string
  background?: string

  boxShadow?: string
  noShadow?: boolean
  border?: string
  enablePointerEvents?: boolean

  translateTextX?: string
  translateTextY?: string
}

export const Badge: React.FC<BadgeProps> = ({
  className,
  id,

  text,

  top,
  right,
  bottom,
  left,

  width,
  minWidth,
  height,
  size = 16,
  fontSize = '0.6rem',
  color,
  background = 'primary',

  boxShadow = '0 0 2px 1px rgba(0, 0, 0, 0.3)',
  noShadow = false,
  border,
  enablePointerEvents = false,

  translateTextX = '0px',
  translateTextY = '0px',
}) => {
  if (
    isUndefined(top) &&
    isUndefined(right) &&
    isUndefined(bottom) &&
    isUndefined(left)
  ) {
    top = '-6px'
    right = '-6px'
  }

  return (
    <Wrapper
      className={className}
      id={id}
      top={top}
      right={right}
      bottom={bottom}
      left={left}
      width={width}
      minWidth={minWidth}
      height={height}
      size={size}
      fontSize={fontSize}
      color={color}
      background={background}
      boxShadow={noShadow ? undefined : boxShadow}
      border={border}
      translateTextX={translateTextX}
      translateTextY={translateTextY}
      pointerEvents={enablePointerEvents ? 'all' : 'none'}
    >
      <span>{text}</span>
    </Wrapper>
  )
}
